// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AMD-s","content":"styles_content__35P1i"};